import { pipe } from '@/utils/common/funtional'

const is_not_NaN = value => !isNaN(value)

export const judge_extreme_value_valid = (value) => is_not_NaN(value) && isFinite(value)

export const judge_value_valid = (value) => {
    return pipe(
        parseFloat,
        is_not_NaN, 
    )(value)
}